import React from 'react';

const UnauthorizedAccess = () => (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '2rem 0rem' }}>
        <h1>Acceso denegado</h1>
        <p>El acceso al recurso especificado ha sido prohibido. Contacte al administrador si se trata de un error.</p>
    </div>
);

export default UnauthorizedAccess;
